<div class="customer-detail-coupons-root" *transloco="let t">
  <ng-container *ngIf="!loadingSummary">
    <app-header>{{ t('business-coupons') }}</app-header>

    <div class="filter-container">
      <div class="left-filters">
        <app-filter-container
          class="left-selectors"
          (selectFilterClick)="updateFilter($event)"
          [baseSimpleChipData]="chipContents"
          [statusChips]="this.statusChips"
          [seriesChips]="this.seriesChips"
          [filters]="this.filters"
        ></app-filter-container>
      </div>
    </div>

    <div
      class="coupon-list"
      *ngIf="coupons?.length || cardVips"
      infinite-scroll
      [infiniteScrollDistance]="0.1"
      [scrollWindow]="false"
      [immediateCheck]="true"
      (scrolled)="pullCoupons()"
    >
    <div *ngFor="let cardVip of cardVips">
      <app-coupon-card-vip-customer *ngIf="cardVip" clickable
                                    showButtonInfo
                                    [couponId]="cardVip.id"
                                    [businessName]="cardVip.business.businessName"
                                    [couponCode]="cardVip.code!"
                                    [startingDate]="cardVip.startingDate!"
                                    [expirationDate]="cardVip.expirationDate!"
                                    [active]="cardVip.active!"
                                    [vipLevel]="cardVip.vipName!"
                                    [familyId]="cardVip.businessLevel.familyPk!"
                                    [familyName]="cardVip.businessLevel.familyName!"
                                    [resellerName]="cardVip.resellerName!"
                                    [discountValue]="cardVip.discount!"
                                    [business]="cardVip.business"
                                    [printers]="cardVip.printers"
                                    [timelineDisabled]="isTimelineDisabled(cardVip.businessLevel.familyPk!)"
                                    [businessImgBase64]="businessSummary?.picture"
                                    [countryName]="cardVip.business.country.name"
                                    [configSeriesDisclaimer]="cardVip.vipConfigSeries?.promotionalTextEnglish">
      </app-coupon-card-vip-customer>
    </div>

      <ng-container *ngFor="let coupon of coupons">
        <app-coupon-card
          *ngIf="coupon.id !== undefined && businessSummary != undefined"
          [headerTitle]="businessSummary.name"
          [picture]="businessSummary.picture"
          [expirationDate]="coupon.expirationDate!"
          [couponStatus]="coupon.status"
          [printerModel]="coupon.productName || ''"
          [description]="coupon.rewardDescription"
          [serial]="coupon.equipmentSerial"
          [couponCode]="coupon.code"
          [reclaimedDate]="coupon.redeemDate!"
          [cost]="coupon.rewardCost"
          [discountValue]="coupon.discountValue"
          [businessId]="coupon.businessId"
          [timelineDisabled]="isTimelineDisabled(coupon.familyId!)"
          [rewardDiscount]="coupon.rewardDiscount"
          [rewardName]="coupon.rewardName"
          [rewardType]="coupon.rewardType"
          [usedDate]="coupon.usedDate!"
          [note]="coupon.note"
          [id]="coupon.id"
          [invoice]="coupon.invoice"
          [resellerIdentification]="coupon.resellerIdentification"
          [businessStatus]="businessSummary.status"
          [disabledAt]="businessSummary.disabledAt"
        >
        </app-coupon-card>
      </ng-container>
      <mat-spinner
        class="loading-more-items"
        *ngIf="pullingCoupons"
      ></mat-spinner>
    </div>
    <ng-container
      *ngIf="!pullingCoupons && !loadingVip && !coupons?.length && !cardVips"
    >
      <app-empty-feed
        icon="list_alt"
        [header]="t('activities-empty')"
        [text]="t('feed-not-listed-description')"
      >
      </app-empty-feed>
    </ng-container>
  </ng-container>
  <mat-spinner
    class="big-loading"
    diameter="100"
    *ngIf="loadingSummary && pullingCoupons && loadingVip"
  ></mat-spinner>
</div>
